import GameCard from '../../../components/GameCard'
import DemoFrame from './DemoFrame'
import { demoGame, demoNoop } from './demoFixtures'

const GAME = demoGame('deadline', 'aston-villa', 'crystal-palace')

/**
 * The most surprising mechanic in the game, and until this ticket the only one written down
 * nowhere in the UI: leave a fixture unpredicted and the deadline fills it 1–1 for you.
 *
 * One card, in the app's own AUTO state, with the 1–1 visible. No countdown line above it: a
 * frozen "Deadline in 0h 30m" in the urgent colour claimed an urgency a rules page has no business
 * claiming, and the lede already says when predictions lock.
 */
export default function DeadlineDemo() {
  return (
    <DemoFrame className="rules-demo--deadline">
      <GameCard
        demo
        game={GAME}
        prediction={{ gameId: GAME.id, homeScore: 1, awayScore: 1, isAutoPredicted: true }}
        actualResult={undefined}
        onClick={demoNoop}
        isBanker={false}
        isDoubleUpActive={false}
        isCleanSweepActive={false}
      />
    </DemoFrame>
  )
}
